const usdcCommon = {
  data: {
    icon: "/imgs/icons/asset/usdc.svg",
    about:
      "USD Coin (known by its ticker USDC) is a stablecoin that is pegged to the U.S. dollar on a 1:1 basis. Every unit of this cryptocurrency in circulation is backed up by $1 that is held in reserve, in a mix of cash and short-term U.S. Treasury bonds. The Centre consortium, which is behind this asset, says USDC is issued by regulated financial institutions.",
    links: [
      {
        name: "Website",
        url: "https://www.circle.com/blog/now-available-usdc-on-polkadot-asset-hub",
      },
      {
        name: "Twitter: @circle",
        url: "https://twitter.com/circle",
        icon: "/imgs/icons/link-x.svg",
      },
      {
        name: "Medium",
        url: "https://medium.com/centre-blog",
        icon: "/imgs/icons/link-medium.svg",
        darkIcon: "/imgs/icons/link-medium-dark.svg",
      },
      {
        name: "Github",
        url: "https://github.com/circlefin",
        icon: "/imgs/icons/link-github.svg",
        darkIcon: "/imgs/icons/link-github-dark.svg",
      },
    ],
  },
};

export default usdcCommon;
